module.exports = "<p>\n  table-settings works!\n</p>\n"